import React from 'react';
import styles from './consultancyStep.module.css';

interface StepTitleProps {
  children: React.ReactNode;
  className?: string;
}

const StepTitle: React.FC<StepTitleProps> = ({ children, className = '' }) => (
  <h2 className={`${styles.stepTitle} ${className}`.trim()}>{children}</h2>
);

export default StepTitle;
